import axios from '@/apis/axios';

class Document
{
    static async getRootFolders()
    {
        const response = await axios.get('/api/documents');

        return response.data.data;
    }

    static async getContentsOfFolder(parentId = null, filter = null, startFromRoot = null)
    {
        let query = '';
        if (filter) {
            query += `filter=${filter}`;
        }
        
        if (startFromRoot) {
            query += `&start-from-root=${startFromRoot}`;
        }

        const response = await axios.get(`/api/documents/${parentId}?${query}`);

        return response.data.data;
    }

    static async getPdfDocument(id)
    {
        const response = await axios.get(`/api/documents/${id}/as-pdf`, { responseType: "blob" });

        return response.data;
    }

    static async getDocumentSignatureStatus(id)
    {
        const response = await axios.get(`/api/documents/${id}/document-signature-status`);

        return response.data;
    }

    static async getSignInProcessDocumentsStatus(documentIds)
    {
        const response = await axios.get(`api/documents/${documentIds}/status`);

        return response.data.data;
    }

    static async getDocumentEmailStatus(documentIds)
    {
        const response = await axios.get(`api/documents/${documentIds}/email-status`);

        return response.data.data;
    }
    
    static async uploadExternalDocument(document, process, companyProcessId)
    {
        const response = await axios.post('api/admin/documents/external-document', {
            process,
            companyProcessId,
            documentId: document.baseName,
            documentName: document.fileName,
            documentPath: document.path,
        });
        
        return response.data.data;
    }
    
    static async loadExternalDocument(document, process, companyProcessId)
    {
        const response = await axios.get(`api/admin/documents/external-documents/${process}/${companyProcessId}/${document}`);
        
        return response.data.data;
    }

    static async requestExternalDocument(process, document)
    {
        const response = await axios.get(`api/admin/documents/external-documents/${process}/${document}/data`);
        
        return response.data.data;
    }

    static async saveExternalDocument(document, process, companyProcessId, data)
    {
        const response = await axios.post(`api/admin/documents/external-documents/${process}/${companyProcessId}/${document}`, {
            data
        });
        
        return response.data.data;
    }
    
    static async delete(document) 
    {
        const response = await axios.delete(`api/admin/documents/${document.id}`);
        
        return response.data;
    }

    static async physicallySigned(document)
    {
        const response = await axios.post(`api/admin/documents/physically-signed/${document.id}`);
        
        return response.data;
    }

    static async dropboxSigned(document)
    {
        const response = await axios.post(`api/admin/documents/dropbox-signed/${document.id}`);
        
        return response.data;
    }

    static async markAsSigned(document)
    {
        const response = await axios.post(`api/admin/documents/mark-as-signed/${document.id}`);
        
        return response.data;
    }

    static async revert(documentId)
    {
        const response = await axios.post(`api/admin/documents/revert/${documentId}`);
        
        return response.data;
    }
}

export default Document;